import type { ConferenceVotingRound, E2E, SupportedLocale } from "@/types";

export function calculateState(votingRound: ConferenceVotingRound, votingRoundReport: E2E.VotingRoundReport = null) {
  if (votingRoundReport && votingRoundReport.status === "finished") return "finished"
  if (votingRound.status !== "scheduled" && votingRound.closedAt === null && votingRound.openedAt === null) return "available"

  return votingRound.status;
}

export function label(votingRound: ConferenceVotingRound, locale: SupportedLocale) {
  if (!votingRound) return ""
  return votingRound.title?.[locale] || votingRound.name || votingRound.reference;
}
